import * as React from 'react'

import * as Dialog from '@radix-ui/react-dialog'
import { motion } from 'framer-motion'

import buildUrl from 'modules/core/lib/buildUrl'
import { isAbsoluteURL } from 'modules/core/lib/isAbsoluteURL'

import * as styles from './index.vanilla.css'

interface LightBoxProps {
  url: string | undefined | null
}

const LightBox = ({ url, children }: React.PropsWithChildren<LightBoxProps>) => {
  const finalUrl = url && isAbsoluteURL(url) ? url : buildUrl(url)

  return (
    <Dialog.Root>
      <Dialog.Trigger>{children}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <motion.div
          transition={{ duration: 0.2, cubicBeizer: [0.175, 0.885, 0.32, 1.275] }}
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
        >
          <Dialog.Content className={styles.modalBox}>
            <img className={styles.img} src={finalUrl} />
          </Dialog.Content>
        </motion.div>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default LightBox
